import { dataTable as actions } from '../actions'

export const reducer = {}

reducer[actions.SET_SORT_BY] = ({
  state,
  action: {
    payload: { id, value }
  }
}) => ({
  ...state,
  sortBy: {
    ...state.sortBy,
    [id]: value
  }
})

reducer[actions.TOGGLE_SORT_ASC] = ({ state, action: { payload: id } }) => ({
  ...state,
  isSortAscending: {
    ...state.isSortAscending,
    [id]: !state.isSortAscending[id]
  }
})

reducer[actions.RESET_SORT_ASC] = ({ state, action: { payload: id } }) => ({
  ...state,
  isSortAscending: {
    ...state.isSortAscending,
    [id]: true
  }
})

reducer[actions.SET_PAGE] = ({
  state,
  action: {
    payload: { id, page }
  }
}) => ({
  ...state,
  page: {
    ...state.page,
    [id]: page
  }
})
